<mat-card appearance="outlined" class="container-fluid container">
  <mat-card-title class="container-header">
    <h4 class="title" mat-dialog-title>Transfert des utilisateurs du groupe <strong> {{sourceGroupName}} </strong></h4>
    <hr>
  </mat-card-title>
  <mat-card-content class="container-content">
    <div class="col-12">
      <form name="form" #f="ngForm">
        <div class="section container-fluid justify-content-center">
          <div class="container-fluid col-md-10">
            <div class="form-group-container form-group mx-0 row">
              <label class="col-xs-12 col-md-3 my-auto pl-0 item-detail-label" for="operationalGroup">Groupe
                destination</label>
              <div class="col-xs-12 col-md-9 px-0">
                <ng-multiselect-dropdown name="transferTargetGroup" [(ngModel)]="targetGroups"
                  [settings]="groupDropDownSettings" placeholder="Sélectionner" [data]="groups" required>
                </ng-multiselect-dropdown>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </mat-card-content>
  <mat-card-footer class="container-footer">
    <div class="col align-items-end modal-footer">
      <button type=" button" class="btn btn-secondary" data-dismiss="modal" (click)="close(false);">Annuler</button>
      <button type="submit" [disabled]="f.form.invalid" class="btn btn-secondary"
        (click)="onSubmit()">Transférer</button>
    </div>
  </mat-card-footer>
</mat-card>